
export interface HashParameterInterface {
  page?: number
  articleId?: string
  moduleId?: string
  pages?: string
}

export function getHashParameter(path: string): HashParameterInterface {
  let params: HashParameterInterface = {}
  params.page = -1
  if (path && path.includes('#')) {
    const hashes = path.replace('#', '').split('&')
    if(hashes) {
      hashes.forEach(item => {
        const splitted = item.split('=')
        try {
          if(splitted[0] == 'p') {
            params.page = parseInt(splitted[1])
          }
          else if(splitted[0] == 'a') {
            params.articleId = splitted[1]
          }
          else if(splitted[0] == 'ps') {
            params.pages = splitted[1]
          }
          else if(splitted[0] == 'm') {
            params.moduleId = splitted[1]
          }
        }
        catch(e) {}
      })
    }
  }
  return params
}


export async function scrollToModuleArticle(moduleId: string, articleId: string, debugLog?: any, isIos?: boolean): Promise<boolean> {
  if(debugLog) {
    debugLog(`** scrollToModuleArticle: moduleId: ${moduleId}, articleId: ${articleId}`)
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
    if(debugLog) {
      debugLog(`** want toscrollToModuleArticle: moduleId: ${moduleId}, articleId: ${articleId}`)
    }
    let found = false
    // find this onea href="/article/1.11762140" data-name="article-1.11762140" data-module-id="7.4612261"
    const moduleElements = document.querySelectorAll(`[data-name="module-${moduleId}"]`);
    if(moduleElements.length > 0) {
      for(let i = 0; i < moduleElements.length; i++) {
        const element = moduleElements[i];
        const articleElement = element.querySelector(`[data-name="article-${articleId}"]`);
        if(articleElement && !found) {
          requestAnimationFrame(() => {
            articleElement.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
          })
          found = true
        }
      }
    }
    if(!found) {
      if(debugLog) {
        debugLog(`** scrollToModuleArticle: no article found: ${articleId}`)
      }
      resolve(false)
    }
    else {
      if(debugLog) {
        debugLog(`** scrollToModuleArticle: article found: ${articleId}`)
      }
      resolve(true)
    }
    }, 400)
  })
}

export async function scrollToArticle(articleId: string, debugLog?: any, isIos?: boolean): Promise<boolean> {
  if(debugLog) {
    debugLog(`** scrollToArticle: articleId: ${articleId}`)
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
    if(debugLog) {
      debugLog(`** want toscrollToArticle: articleId: ${articleId}`)
    }
    const element = document.querySelector(`[data-name="article-${articleId}"]`);
    if (element) {
      //request animation frame
      requestAnimationFrame(() => {
        element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
      })
      //element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
      if(debugLog) {
        debugLog(`** scrolled scrollToArticle: articleId: ${articleId}`)
      }
      resolve(true)
    }
    else {
      if(debugLog) {
        debugLog(`** scrollToArticle: no article found: ${articleId}`)
      }
      resolve(false)
      }
    }, 400)
  })
}

export async function scrollToModule(moduleId: string, debugLog?: any, isIos?: boolean): Promise<boolean> {
  if(debugLog) {
    debugLog(`** scrollToModule: moduleId: ${moduleId}`)
  }
  else {
    console.log(`** scrollToModule: moduleId: ${moduleId}`)
  }
  return new Promise((resolve, reject) => {
    setTimeout(() => {
    const element = document.querySelector(`[data-name="module-${moduleId}"]`);
    if (element) {
      element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
      if(debugLog) {
        debugLog(`** scrollToModule: moduleId: ${moduleId}`)
      }
      resolve(true)
    }
    else {
      if(debugLog) {
        debugLog(`** scrollToModule: no module found: ${moduleId}`)
      }
      resolve(false)
    }
  }, 400)
  })
}